/**
 * Nomes de grupos/seções das colunas de técnicos no Board.
 * Usado para regras de menu de contexto (ex.: desabilitar "Excluir OS" em certas seções).
 */
export const BOARD_GROUP_EM_DESLOCAMENTO = 'Em deslocamento';
export const BOARD_GROUP_EM_SERVICO = 'Em serviço';
export const BOARD_GROUP_PREVISTO_HOJE = 'Previsto para hoje';
export const BOARD_GROUP_PREVISTAS_AMANHA = 'Previstas para amanhã';
export const BOARD_GROUP_FUTURA = 'FUTURA';

/** Em serviço: 0 ativa, 1 aguardando atendimento, 2 aguardando assinatura. */
export function emServicoQueueRank(order) {
  if (order?.isAguardandoAssinatura) return 2;
  if (order?.isAguardandoAtendimento) return 1;
  return 0;
}

/** Seções ativas (deslocamento / serviço): só aparecem com OS; drop bloqueado. */
export function isBoardLiveServiceGroup(groupName) {
  return (
    groupName === BOARD_GROUP_EM_DESLOCAMENTO ||
    groupName === BOARD_GROUP_EM_SERVICO
  );
}

/**
 * Garante duas seções distintas: OS com isDeslocamento → Em deslocamento; demais ativas → Em serviço.
 * Cobre resposta antiga (tudo em Em serviço) e dados já separados pela API.
 * Aguardando atendimento e aguardando assinatura permanecem em Em serviço, após as OS em serviço/pausa.
 */
export function normalizeTechnicianLiveServiceGroups(groups) {
  if (!groups || typeof groups !== 'object') return groups || {};
  const desloc = [];
  const servico = [];
  const seenDesloc = new Set();

  const pushDesloc = (order) => {
    const key = String(order?.id ?? order?.TB02115_CODIGO ?? '');
    if (key && seenDesloc.has(key)) return;
    if (key) seenDesloc.add(key);
    desloc.push(order);
  };

  for (const order of groups[BOARD_GROUP_EM_DESLOCAMENTO] || []) {
    pushDesloc(order);
  }
  for (const order of groups[BOARD_GROUP_EM_SERVICO] || []) {
    if (order?.isDeslocamento === true) pushDesloc(order);
    else servico.push(order);
  }

  servico.sort((a, b) => emServicoQueueRank(a) - emServicoQueueRank(b));

  return {
    ...groups,
    [BOARD_GROUP_EM_DESLOCAMENTO]: desloc,
    [BOARD_GROUP_EM_SERVICO]: servico,
  };
}

/**
 * Indica se a opção "Excluir OS" deve ficar desabilitada no menu de contexto
 * para a seção informada (colunas de técnicos).
 * @param {string} [groupName] - Nome do grupo (ex.: 'Em serviço', 'Previsto para hoje')
 * @returns {boolean}
 */
export function isExcluirOSDisabledForGroup(groupName) {
  return (
    isBoardLiveServiceGroup(groupName) ||
    groupName === BOARD_GROUP_PREVISTO_HOJE
  );
}
